<template>
  <base-wrapper
    ref="root"
    :component="VCol"
    v-bind="mergedAttrs"
    v-on="$listeners"
  >
    <slot />

    <template
      #default
    >
      <slot
        name="default"
      />
    </template>
  </base-wrapper>
</template>

<script>
import BaseWrapper from './BaseWrapper.vue'
import { VCol } from 'vuetify/lib/components'
export default {
  name: 'VColWrapper',

  components: {
    BaseWrapper
  },

  props: {
    /**
     * Applies the align-items CSS property. Available options are start, center, end, auto, baseline and stretch.
     */
    alignSelf: {
      type: String,
      default: undefined
    },
    /**
     * Sets the default number of columns the component extends. Available options are 1 -> 12 and auto.
     */
    cols: {
      type: [Boolean, String, Number],
      default: false
    },
    /**
     * Changes the number of columns on large and greater breakpoints.
     */
    lg: {
      type: [Boolean, String, Number],
      default: false
    },
    /**
     * Changes the number of columns on medium and greater breakpoints.
     */
    md: {
      type: [Boolean, String, Number],
      default: false
    },
    /**
     * Sets the default offset for the column.
     */
    offset: {
      type: [String, Number],
      default: undefined
    },
    /**
     * Changes the offset of the component on large and greater breakpoints.
     */
    offsetLg: {
      type: [String, Number],
      default: undefined
    },
    /**
     * Changes the offset of the component on medium and greater breakpoints.
     */
    offsetMd: {
      type: [String, Number],
      default: undefined
    },
    /**
     * Changes the offset of the component on small and greater breakpoints.
     */
    offsetSm: {
      type: [String, Number],
      default: undefined
    },
    /**
     * Changes the offset of the component on extra large and greater breakpoints.
     */
    offsetXl: {
      type: [String, Number],
      default: undefined
    },
    /**
     * Sets the default order for the column.
     */
    order: {
      type: [String, Number],
      default: undefined
    },
    /**
     * Changes the order of the component on large and greater breakpoints.
     */
    orderLg: {
      type: [String, Number],
      default: undefined
    },
    /**
     * Changes the order of the component on medium and greater breakpoints.
     */
    orderMd: {
      type: [String, Number],
      default: undefined
    },
    /**
     * Changes the order of the component on small and greater breakpoints.
     */
    orderSm: {
      type: [String, Number],
      default: undefined
    },
    /**
     * Changes the order of the component on extra large and greater breakpoints.
     */
    orderXl: {
      type: [String, Number],
      default: undefined
    },
    /**
     * Changes the number of columns on small and greater breakpoints.
     */
    sm: {
      type: [Boolean, String, Number],
      default: false
    },
    /**
     * Specify a custom tag used on the root element.
     */
    tag: {
      type: String,
      default: 'div'
    },
    /**
     * Changes the number of columns on extra large and greater breakpoints.
     */
    xl: {
      type: [Boolean, String, Number],
      default: false
    }
  },

  computed: {
    VCol () {
      return VCol
    },

    mergedAttrs () {
      return {
        ...this.$props,
        ...this.$attrs
      }
    }
  },

  methods: {
    getRootElement () {
      return this.$refs.root?.$el || this.$refs.root
    }
  }
}
</script>
